// extracted by mini-css-extract-plugin
module.exports = {"TEST":"blue","PRIMARY":"#51b79d","SECONDARY":"#425d6c","ASSENT":"#6c757d","TEXT_PRIMARY":"#68717a","TEXT_SECONDARY":"#6c757d","TEXT_WHITE":"#fff"};